exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-tour[data-v-70804268]{z-index:15;position:relative}", ""]);

// exports
